var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgWhiteList(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4 2.766H7.6C6.164 2.766 5 3.874 5 5.242v22.28c0 1.367 1.164 2.476 2.6 2.476h16.8c1.436 0 2.6-1.109 2.6-2.477V5.242c0-1.368-1.164-2.476-2.6-2.476z",
    fill: "#E6A273"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M27 6.618v20.906c.003.326-.062.649-.191.95a2.47 2.47 0 01-.56.808 2.61 2.61 0 01-.841.543 2.71 2.71 0 01-.996.193H8.16l-1.764-2.483 18.74-22.52L27 6.619z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.565 4.398H8.43c-1.238 0-2.242.956-2.242 2.135v20.133c0 1.18 1.004 2.135 2.242 2.135h15.135c1.238 0 2.241-.956 2.241-2.135V6.533c0-1.179-1.003-2.135-2.241-2.135z",
    fill: "#FAFEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.606 9.086H9.39c-.55 0-.994.424-.994.947 0 .523.445.947.994.947h13.217c.55 0 .994-.424.994-.947 0-.523-.445-.947-.994-.947zM22.606 12.727H9.39c-.55 0-.994.423-.994.947 0 .523.445.947.994.947h13.217c.55 0 .994-.425.994-.947 0-.524-.445-.947-.994-.947zM22.606 16.375H9.39c-.55 0-.994.424-.994.947 0 .523.445.947.994.947h13.217c.55 0 .994-.424.994-.947 0-.523-.445-.947-.994-.947zM22.606 20.016H9.39c-.55 0-.994.424-.994.947 0 .523.445.947.994.947h13.217c.55 0 .994-.424.994-.947 0-.523-.445-.947-.994-.947zM22.606 23.656H9.39c-.55 0-.994.424-.994.947 0 .523.445.947.994.947h13.217c.55 0 .994-.424.994-.947 0-.523-.445-.947-.994-.947z",
    fill: "#CEE9F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.347 7.262h-5.57a3.114 3.114 0 01-2.147-.847 2.824 2.824 0 01-.889-2.045v-.128c0-.39.163-.763.452-1.039a1.58 1.58 0 011.09-.43h8.552c.41 0 .801.155 1.09.43.29.276.451.65.451 1.039v.134a2.823 2.823 0 01-.889 2.039 3.113 3.113 0 01-2.14.847z",
    fill: "#000",
    opacity: 0.15
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.806 6.483h-5.57a3.114 3.114 0 01-2.14-.841 2.825 2.825 0 01-.896-2.034v-.14c0-.39.163-.763.452-1.038a1.58 1.58 0 011.09-.43h8.552c.203 0 .404.037.592.11.188.074.358.182.502.318.144.136.258.299.335.477.078.178.118.37.118.563v.14a2.825 2.825 0 01-.895 2.034 3.114 3.114 0 01-2.14.84z",
    fill: "#FFD580"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5 2)",
    d: "M0 0h22v28H0z"
  })))));
}
export default SvgWhiteList;